export const FinanceDetailsReviewQuestions = {
  titleKey: 'affordabilityCalculator.sections.financeDetails',
  term: {
    labelKey: 'affordabilityCalculator.review.financeDetails.term',
    value: 'affordabilityCalculator.review.financeDetails.term.value',
  },
  productKey: 'affordabilityCalculator.review.financeDetails.product',
  financingAmountKey: 'affordabilityCalculator.review.financeDetails.financingAmount',
  depositKey: 'affordabilityCalculator.review.financeDetails.deposit',
  regionKey: 'affordabilityCalculator.review.financeDetails.region',
  dependentsKey: 'affordabilityCalculator.review.financeDetails.dependents',
  numberOfApplicantsKey: 'affordabilityCalculator.review.financeDetails.numberOfApplicants',
};

export const ApplicantDetailsReviewQuestions = {
  titleKey: 'affordabilityCalculator.review.applicants.applicant',
  income: {
    titleKey: 'affordabilityCalculator.review.applicants.income',
    employmentType: 'affordabilityCalculator.review.applicants.income.employmentType',
    employmentTypeValue: 'affordabilityCalculator.review.employmentType.',
    basicAnnualSalary: 'affordabilityCalculator.review.applicants.income.basicAnnualSalary',
    bonus: 'affordabilityCalculator.review.applicants.income.bonus',
    commission: 'affordabilityCalculator.review.applicants.income.commission',
    overtime: 'affordabilityCalculator.review.applicants.income.overtime',
    guaranteedEmployeeBenefits: 'affordabilityCalculator.review.applicants.income.guaranteedEmployeeBenefits',
    timeTrading: 'affordabilityCalculator.review.applicants.income.timeTrading',
    dividendsRecentYear: 'affordabilityCalculator.review.applicants.income.dividendsRecentYear',
    dividendsPreviousYear: 'affordabilityCalculator.review.applicants.income.dividendsPreviousYear',
    basicAnnualSalaryRecentYear: 'affordabilityCalculator.review.applicants.income.basicAnnualSalaryRecentYear',
    basicAnnualSalaryPreviousYear: 'affordabilityCalculator.review.applicants.income.basicAnnualSalaryPreviousYear',
    netTaxableIncomeRecentYear: 'affordabilityCalculator.review.applicants.income.netTaxableIncomeRecentYear',
    netTaxableIncomePreviousYear: 'affordabilityCalculator.review.applicants.income.netTaxableIncomePreviousYear',
    timeRemainingYears: 'affordabilityCalculator.review.applicants.income.timeRemainingYears',
    timeRemainingMonths: 'affordabilityCalculator.review.applicants.income.timeRemainingMonths',
  },
  otherIncome: {
    titleKey: 'affordabilityCalculator.review.applicants.otherIncome',
    maintenanceIncome: 'affordabilityCalculator.review.applicants.otherIncome.maintenanceIncome',
    pensionIncome: 'affordabilityCalculator.review.applicants.otherIncome.pensionIncome',
    rentalIncome: 'affordabilityCalculator.review.applicants.otherIncome.rentalIncome',
  },
  benefitsAndCredits: {
    titleKey: 'affordabilityCalculator.review.applicants.benefitsAndCredits',
    childBenefit: 'affordabilityCalculator.review.applicants.benefitsAndCredits.childBenefit',
    universalTaxCredits: 'affordabilityCalculator.review.applicants.benefitsAndCredits.universalTaxCredits',
    stateDisabilityAllowance: 'affordabilityCalculator.review.applicants.benefitsAndCredits.stateDisabilityAllowance',
  },
  creditCommitments: {
    titleKey: 'affordabilityCalculator.review.applicants.outgoings',
    subTitleKey: 'affordabilityCalculator.review.applicants.creditCommitments',
    unsecuredLoanRepayments: 'affordabilityCalculator.review.applicants.creditCommitments.unsecuredLoanRepayments',
    securedLoanRepayments: 'affordabilityCalculator.review.applicants.creditCommitments.securedLoanRepayments',
    creditStoreCardsBalance: 'affordabilityCalculator.review.applicants.creditCommitments.creditStoreCardsBalance',
    maintenance: 'affordabilityCalculator.review.applicants.creditCommitments.maintenance',
  },
  expenditure: {
    subTitleKey: 'affordabilityCalculator.review.applicants.expenditure',
    childcare: 'affordabilityCalculator.review.applicants.creditCommitments.childcare',
    travelExpenses: 'affordabilityCalculator.review.applicants.creditCommitments.travelExpenses',
  },
};
